import * as React from "react";
import { SVGProps } from "react";

const InflowIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.6 20.0488H19.2C19.5556 20.0488 19.85 19.7544 19.85 19.3988C19.85 19.0432 19.5556 18.7488 19.2 18.7488H5.6C5.24439 18.7488 4.95 19.0432 4.95 19.3988C4.95 19.7544 5.24439 20.0488 5.6 20.0488Z"
      fill="#45A159"
      stroke="#45A159"
      strokeWidth="0.1"
    />
    <path
      d="M19.2593 5.05784C19.3892 4.92797 19.45 4.76303 19.45 4.59848C19.45 4.43394 19.3892 4.269 19.2593 4.13913C19.0078 3.88761 18.5921 3.88761 18.3406 4.13913L7.1406 15.3391C6.88907 15.5907 6.88907 16.0063 7.1406 16.2578C7.39212 16.5094 7.80778 16.5094 8.05931 16.2578L19.2593 5.05784Z"
      fill="#45A159"
      stroke="#45A159"
      strokeWidth="0.1"
    />
    <path
      d="M15.816 16.4484C16.1716 16.4484 16.466 16.1541 16.466 15.7984C16.466 15.4428 16.1716 15.1484 15.816 15.1484L8.25 15.1484L8.25 7.58244C8.25 7.22682 7.95561 6.93244 7.6 6.93244C7.24439 6.93244 6.95 7.22682 6.95 7.58244L6.95 15.7984C6.95 16.1541 7.24439 16.4484 7.6 16.4484L15.816 16.4484Z"
      fill="#45A159"
      stroke="#45A159"
      strokeWidth="0.1"
    />
  </svg>
);

export default InflowIcon;
